import script from "./PaymentDiscountOffers.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDiscountOffers.vue?vue&type=script&setup=true&lang=js"

import "./PaymentDiscountOffers.vue?vue&type=style&index=0&id=16c2d626&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c2d626"]])

export default __exports__